import { RouteRecordRaw } from 'vue-router';
import { FormBuilderPage } from '@/features/FormBuilder';

export const routeName = 'FormBuilder';

export const route: RouteRecordRaw = {
  path: '/construtor-formularios',
  name: routeName,
  component: FormBuilderPage,
  meta: {
    requiresAuth: true,
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
